import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationResult } from '@azure/msal-browser';
import { User } from '@models/user';
import { AuthService } from '@services/auth.service';
import { DialogService } from '@services/dialog.service';
import { SsoService } from '@services/sso.service';

@Component({
  selector: 'app-sso',
  templateUrl: './sso.component.html',
  styleUrls: ['./sso.component.scss'],
  standalone: false
})
export class SsoComponent implements OnInit {

  public message: string = "Bitte warten...";

  constructor(
    private router: Router,
    private ssoService: SsoService,
    private authService: AuthService,
    private dialogService: DialogService,
  ) { }

  ngOnInit(): void {
    this.ssoService.subscribeRedirect$().subscribe((result: AuthenticationResult | null) => {
      if (result?.state == 'manual_login') {
        this.authService.validateIdToken(result.idToken).then((user: any) => {
          this.router.navigate(['/app']);
        }).catch((error: any) => {
          this.router.navigate(['/login']).then(() => {
            setTimeout(() => {

              let errorMessage = "Die Single Sign On-Anmeldung hat leider nicht geklappt.";

              if (error! == "USER_NOT_FOUND") {
                errorMessage = "Sie haben Ihren Single Sign On-Zugang noch nicht mit Ihrem MedienCenter-Account verbunden. Bitte melden Sie sich mit Ihren Zugangsdaten an und verbinden Sie Ihren Single Sign On-Zugang in den Einstellungen.";
                this.dialogService.alert(null, errorMessage, 'info', 0);
              } else if (error) {
                errorMessage = "Die Single Sign On-Anmeldung hat leider nicht geklappt.";
                this.dialogService.alert(null, errorMessage, 'danger');
              } else {
                this.dialogService.alert(null, errorMessage, 'danger');
              }
            }, 500);
          });
        });
      } else if (result?.state == 'sso_modal') {
        this.ssoService.linkAccount(result.uniqueId).then(() => {
          return this.authService.validateIdToken(result.idToken);
        }).then(() => {
          return this.authService.refreshUser();
        }).then(() => {
          return this.authService.getCurrentUser();
        }).then((user: User | null) => {
          this.router.navigate(['/app']).then(() => {
            setTimeout(() => {
              if (user?.lastFtpLoginDate) {
                this.dialogService.alert(null, "Bitte beachten Sie, dass ein neues Passwort für Ihren FTP-Zugang vergeben wurde. Sie können dieses auf der Startseite jederzeit einsehen.", "warning");
              }

              this.dialogService.alert(null, "Die Single Sign On-Verknüpfung war erfolgreich.", 'success');
            });
          });
        }).catch((error: any) => {
          this.router.navigate(['/login']).then(() => {
            setTimeout(() => {
              let errorMessage = "Die Single Sign On-Verknüpfung hat leider nicht geklappt.";
              this.dialogService.alert(null, errorMessage, 'danger');
            });
          });
        });
      } else if (result?.state == 'settings_link') {
        this.ssoService.linkAccount(result.uniqueId).then(() => {
          return this.authService.validateIdToken(result.idToken);
        }).then(() => {
          return this.authService.refreshUser();
        }).then(() => {
          return this.authService.getCurrentUser();
        }).then((user: User | null) => {
          this.router.navigate(['/app/common/settings']).then(() => {
            setTimeout(() => {
              if (user?.lastFtpLoginDate) {
                this.dialogService.alert(null, "Bitte beachten Sie, dass ein neues Passwort für Ihren FTP-Zugang vergeben wurde. Sie können dieses auf der Startseite jederzeit einsehen.", "warning");
              }

              this.dialogService.alert(null, "Die Single Sign On-Verknüpfung war erfolgreich.", 'success');
            });
          });
        }).catch((error: any) => {
          this.router.navigate(['/login']).then(() => {
            setTimeout(() => {
              let errorMessage = "Die Single Sign On-Verknüpfung hat leider nicht geklappt.";
              this.dialogService.alert(null, errorMessage, 'danger');
            });
          });
        });
      } else if (result?.state == 'settings') {
        this.message = "Ihre Einstellungen werden aktualisiert, dies kann bis zu 10 Sekunden dauern...";

        // wait 8sec, otherwise the updated user data is not available yet
        new Promise(resolve => setTimeout(resolve, 8000)).then(() => {
          return this.authService.validateIdToken(result.idToken);
        }).then((user: any) => {
          this.router.navigate(['/app/common/settings']);
        }).catch((error: any) => {
          this.router.navigate(['/login']).then(() => {
            setTimeout(() => {
              let errorMessage = "Die Single Sign On-Anmeldung hat leider nicht geklappt.";
              this.dialogService.alert(null, errorMessage, 'danger');
            });
          });
        });
      } else if (result?.state == 'password_reset') {
        this.authService.validateIdToken(result.idToken).then((user: any) => {
          this.router.navigate(['/app']).then(() => {
            setTimeout(() => {
              let message = "Sie haben Ihr Passwort für Single Sign On erfolgreich zurückgesetzt.";
              this.dialogService.alert(null, message, 'success');
            });
          });
        }).catch((error: any) => {
          this.router.navigate(['/login']).then(() => {
            setTimeout(() => {
              let errorMessage = "Die Single Sign On-Anmeldung hat leider nicht geklappt.";
              this.dialogService.alert(null, errorMessage, 'danger');
            });
          });
        });
      } else if (result?.state == 'logout') {
        this.router.navigate(['/login']);
      } else {
        this.router.navigate(['/app']);
      }
    });
  }

}
